import React, { useReducer, useContext } from "react";
import { claimReducer as reducer } from "../reducers/claimReducer";
import { claimActions as actions } from "../actions/claimActions";

const initialValue = {
  claims: null,
  members: null,
};

const claimContext = React.createContext();

const ClaimContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <claimContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </claimContext.Provider>
  );
};

export const useClaimContext = () => React.useContext(claimContext);
export default ClaimContext;
